import React, {Component} from "react";
import axios from 'axios';
import InputMask from 'react-input-mask';

const ERROR_400 = 400;

export default class Register extends Component {
    constructor() {
        super(...arguments);

        this.state = {
            accept_terms: '',
            email: '',
            phone: '',
            password: '',
            password_confirmation: '',
            success: false,
            errors: '',
        };

        this.register = this.register.bind(this);
    }

    handleChangeTextInput(attribute) {
        return (e) => {
            let value = e.target.value;
            this.setState({[attribute]: value});
        }
    }

    register() {
        axios.post('/register', {
            accept_terms: this.state.accept_terms,
            email: this.state.email,
            phone: this.state.phone,
            password: this.state.password,
            password_confirmation: this.state.password_confirmation,
        }).then((data) => {
            this.setState({
                success: true,
                errors: false,
            });
        }).catch((error) => {
            this.setState({errors: error.response.data.errors});
        })
    }

    handleChangePhoneNumber(attribute) {
        return (e) => {
            let getValue = e.target.value;
            let replaceCode = getValue.replace('+', "");
            let value = replaceCode.replace(/[^0-9]+/g, "");

            this.setState({[attribute]: value});
        }
    }

    render() {
        const {errors, success} = this.state;
        return (
            <div>
                {success ?
                    <div className="text-center">
                        Ви успішно зареєструвалися. Для завершення підтвердіть реєстрацію.
                        Лист з інструкцією надіслано на ел. адресу.
                        <a href="/" className="btn btn-primary mt-4">Головна</a>
                    </div>
                    :
                    <div className="register">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email">Електронна пошта <span
                                        className="text-danger">*</span></label>
                                    <input id="email"
                                           type="email"
                                           className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                           onChange={this.handleChangeTextInput('email')}
                                           name="email"
                                           placeholder="Введіть email"
                                           required
                                    />
                                    {errors.email &&
                                    <span className="invalid-feedback">
                                        <strong>{errors.email}</strong>
                                    </span>
                                    }
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Номер мобільного телефону <span
                                        className="text-danger">*</span></label>
                                    <InputMask
                                        mask="+380(99)-999-99-99"
                                        onChange={this.handleChangePhoneNumber('phone')}
                                    >
                                        {(inputProps) => <input
                                            {...inputProps}
                                            id="phone"
                                            type="text"
                                            className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                            name="phone"
                                            placeholder="+380(00)-000-00-00"
                                            required
                                        />}
                                    </InputMask>
                                    {errors.phone &&
                                    <span className="invalid-feedback">
                                        <strong>{errors.phone}</strong>
                                    </span>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="password">Пароль <span className="text-danger">*</span></label>
                                    <input id="password"
                                           type="password"
                                           className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                           onChange={this.handleChangeTextInput('password')}
                                           name="password"
                                           placeholder="Введіть пароль"
                                           required
                                    />
                                    {errors.password &&
                                    <span className="invalid-feedback">
                                        <strong>{errors.password}</strong>
                                    </span>
                                    }
                                </div>
                                <div className="form-group">
                                    <label htmlFor="password_confirmation">Підтвердити пароль <span
                                        className="text-danger">*</span></label>
                                    <input id="password_confirmation"
                                           type="password"
                                           className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                                           onChange={this.handleChangeTextInput('password_confirmation')}
                                           name="password_confirmation"
                                           placeholder="Введіть пароль для підтверження"
                                           required
                                    />
                                    {errors.password &&
                                    <span className="invalid-feedback">
                                        <strong>{errors.password}</strong>
                                    </span>
                                    }
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className="custom-control custom-checkbox">
                                        <input name="accept_terms"
                                               type="checkbox"
                                               className={`custom-control-input ${errors.accept_terms ? 'is-invalid' : ''}`}
                                               id="accept_terms"
                                               checked={this.state.accept_terms}
                                               onChange={() => this.setState({accept_terms: !this.state.accept_terms})}
                                               required
                                        />
                                        <label className="custom-control-label " htmlFor="accept_terms">
                                            <small className="form-text">
                                                Я даю згоду на обробку даних, зазначених при реєстрації і підтверджую,
                                                що ознайомлений (-а) зі своїми правами відповідно до Закону України
                                                «Про захист персональних даних»
                                            </small>
                                        </label>
                                        {errors.accept_terms &&
                                        <span className="invalid-feedback">
                                    <strong>{errors.accept_terms}</strong>
                                </span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <button id="register" type="button" onClick={this.register}
                                        className="btn btn-primary min-w"
                                        disabled={!this.state.accept_terms}
                                >
                                    Зареєструватися
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

